import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import { OrderManagementConfig } from "../../../../objects/users/user";
import { BlurUtil } from "../../../../common/utils/blurUtil";
import * as ps from "perfect-scrollbar";
import { ConfigService } from "../../../../services/configService";
import { DatePickerComponent } from "../../../common/datepicker/datepicker.component";
import { IMyDate, IMyOptions, INgxMyDpOptions } from "ngx-mydatepicker";


@Component({
    selector: 'order-export-modal',
    templateUrl: 'order-export-modal.component.html',
    moduleId: module.id.toString()
})
export class OrderExportModalComponent {
    @Input()
    public idToBlur: string;

    @ViewChild('orderExportModal')
    public orderExportModal: ModalDirective;

    @ViewChild("exportForm")
    public exportForm: NgForm;

    @ViewChild('orderExportModalRef')
    public orderExportModalRef: ElementRef;

    @ViewChildren(DatePickerComponent) dpList: QueryList<DatePickerComponent>;

    public dateFrom: any;
    public dateTo: any;

    public optionFrom: INgxMyDpOptions = {
        dateFormat: 'mm.dd.yyyy',
    };

    public optionTo: INgxMyDpOptions = {
        dateFormat: 'mm.dd.yyyy',
    };

    public constructor(public configService: ConfigService) {

    }

    public async show(): Promise<void> {
        this.dpList.forEach(dp => dp.clearDate());

        this.orderExportModal.show();
        BlurUtil.blurMenu(this.idToBlur);

        this.dateFrom = null;
        this.dateTo = null;
    }

    public ngOnInit(): void {
        ps.initialize(this.orderExportModalRef.nativeElement);
    }

    public onModalHidden(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public exportOrders(isValid: boolean): void {
        if (!isValid)
            return;

        window.open(`${this.configService.config.AdminUrl}/order/export/all?datefrom=${this.dateFrom}&dateto=${this.dateTo}`, '_blank'); // TODO add params

        this.orderExportModal.hide();
    }

    public handleDateFrom(event: any) {
        this.dateFrom = this.getDate(event.date);

        this.disableUntil(event.date);
    }

    public handleDateTo(event: any) {
        this.dateTo = this.getDate(event.date);

        this.disableSince(event.date);
    }

    private getDate(date: any) {
        return new Date(date['year'], date['month'] - 1, date['day'], 0, 0, 0);
    }

    disableUntil(date: IMyDate) {
        let copy = this.getCopyOfOptions(this.optionTo);

        copy.disableUntil = {year:date.year,
            month: date.month,
            day: date.day};

        this.optionTo = copy;
    }

    disableSince(date: IMyDate) {
        let copy = this.getCopyOfOptions(this.optionFrom);

        copy.disableSince = {year:date.year,
            month: date.month,
            day: date.day};

        this.optionFrom = copy;
    }

    // Returns copy of myOptions
    getCopyOfOptions(val: any): IMyOptions {
        return JSON.parse(JSON.stringify(val));
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/order-export-modal/order-export-modal.component.ts